import { ApiPutRequest } from './api-put-request';
import { ApiParameters } from './api-parameters';
import { Order } from '../../interfaces/order';
import { TrackingChannel } from '../../enums/tracking-channel';
import { SplittestValuePair } from '../../interfaces/splittest-value-pair';

export class UpdateSplittestValuePairOnOrderRequest extends ApiPutRequest
{
    public constructor(order: Order, splittestValuePair: SplittestValuePair, trackingChannel: TrackingChannel, webapiBasepath: string)
    {
        const parameters = new ApiParameters().addQueryParameter('orderid', order.Id).addQueryParameter('trackingChannel', trackingChannel);
        super('order/updateordercontext', parameters, null, {"SplitTestValuePair": splittestValuePair}, webapiBasepath);
    }
}